//This viewmodel is by both media-list-item and media-tile. Be careful!
var ko = require('knockout'),
  cart = require('_components/organisms/shopping-cart/shopping-cart-storage'),
  analytics = require('_js/analytics-ecommerce');

function getAvailability(availability) {
  if (!availability) return '';

  switch (availability.Status) {
    case 1:
      return 'open';
    case 2:
      return 'few';
    case 3:
    case 4:
      return 'full';
  }
}

function GetCourseType(courseType) {
  switch (courseType) {
    case 2:
      return 'icon-fagdag';
    case 3:
      return 'icon-screen';
    case 4:
      return 'icon-fagdag'; //Utenlandskurs
    case 5:
      return 'icon-bundle';
    case 6:
      return 'icon-program';
    default:
      return 'icon-globe';
  }
}

function MediaListModel(params) {
  var self = this;
  self.item = params.item;
  self.texts = params.texts;
  self.hasRNFri = params.hasRNFriProduct === 'True' ? true : false;

  var netCourse = self.item.EventType === 3 || self.item.EventType === 8;
  var onsiteCourse = self.item.EventType === 1;
  var showRNFriButton =
    (self.hasRNFri && netCourse) ||
    (self.hasRNFri && onsiteCourse && self.item.FreeOfChargeWithRnFri);

  self.hasRNFriProduct = showRNFriButton;
  self.quickPurchaseOnlineCourse = params.quickPurchaseOnlineCourse;
  //This is a temporary way to show image
  self.image = 'url(' + self.item.ImageUrl + ')';
  self.isPurchased = ko.observable(
    cart.findCourseInCart(cart.getCart(), self.item.Id) ? true : false
  );
  self.isQuickPurchased = ko.observable(false);
  self.courseId = null;
  self.showCart = self.item.ShowCart;
  self.truncateClass = ko.pureComputed(function() {
    return 'truncate short';
  });

  //Dynamic CSS classes
  self.availability = getAvailability(self.item.Availability);

  self.eventType = GetCourseType(self.item.EventType);

  self.authorizationCredits = self.item.AuthorizationCredits;

  self.filterAuthorizationType = ko
    .observable('1')
    .subscribeTo('filterAuthorizationTypeUpdated', true);

  self.addToCart = function(el, ev) {
    ev.preventDefault();

    self.courseId = self.item.Id;
    cart.addCourseToCart(self.item);
    self.isPurchased(true);
  };

  self.trackAndRedirect = function() {
    analytics.productClickedFromCatalog(self.item);
  };

  self.trackAndRedirectMousedown = function(data, event) {
    if (event.which === 2) {
      analytics.productMouseDownEvent(self.item);
      window.open(data.Url, '_blank');
      return;
    }
    if (event.which === 3) {
      analytics.productMouseDownEvent(self.item);
    }
  };

  // Lytt til changes på handlekurven. Hvis element er fjernet som matcher denne IDen
  ko.postbox.subscribe(
    'removeCourse',
    function(course) {
      if (course.Id === this.courseId) {
        this.isPurchased(false);
      }
    },
    this,
    true
  );
}

module.exports = MediaListModel;
